"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Modal = _interopRequireDefault(require("./Modal"));

var _confirm = _interopRequireDefault(require("./core/confirm"));

var _types = require("./types");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_Modal.default.info = function (props) {
  return (0, _confirm.default)((0, _types.withInfo)(_objectSpread(_objectSpread({}, _constants.defaultConfig), props)));
};

_Modal.default.success = function (props) {
  return (0, _confirm.default)((0, _types.withSuccess)(_objectSpread(_objectSpread({}, _constants.defaultConfig), props)));
};

_Modal.default.error = function (props) {
  return (0, _confirm.default)((0, _types.withError)(_objectSpread(_objectSpread({}, _constants.defaultConfig), props)));
};

_Modal.default.confirm = function (props) {
  return (0, _confirm.default)((0, _types.withConfirm)(_objectSpread(_objectSpread(_objectSpread({}, _constants.confirmProps), _constants.defaultConfig), props)));
};

_Modal.default.warning = _types.modalWarn;
_Modal.default.warn = _types.modalWarn;
var _default = _Modal.default;
exports.default = _default;